import { connect } from 'react-redux';
import DuplicateModal from './DuplicateModal';
import { duplicateACPackagedSub } from '../../redux/ac_packaged_unit/ac_packaged_sub_actions';

const mapStateToProps = state => ({
  isDuplicating: state.ac.packagedSub.isDuplicating,
  errorMessage: state.ac.packagedSub.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateACPackagedSub(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/duplicate/ACPackagedSubDuplicateModal.js